import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import  jwtDecode  from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private router: Router) { }

  public isNotExpiredToken(token: string): boolean {
    try {
      const decode: any = jwtDecode(token);
      const exp = decode['exp'];
      return (Date.now() / 1000).toFixed(0) < exp;
    } catch (error) {
      return false;
    }
  }

  public cleanVariablesStorage(): void {
    localStorage.removeItem('tokenV2');
    localStorage.removeItem('contagemToken');
    localStorage.removeItem('packToken');
    localStorage.removeItem('balancoToken');
    localStorage.removeItem('branch');
    localStorage.removeItem('contagemComponentCode');
    localStorage.removeItem('balancoComponentCode');
    localStorage.removeItem('avulsaComponentCode');
    localStorage.removeItem('packComponentCode');
    localStorage.removeItem('componentCodeToken');
    sessionStorage.removeItem('detailCountData');
  }

  public saveTokenV2(res: any): void {
    localStorage.removeItem('tokenV2');
    localStorage.setItem('tokenV2', res);
  }

  public saveCountToken(token: string): void {
    localStorage.removeItem('contagemToken');
    localStorage.setItem('contagemToken', token);
  }

  public saveEmbarqueToken(token: string): void {
    localStorage.removeItem('embarqueToken');
    localStorage.setItem('embarqueToken', token);
  }

  public saveAvulsaToken(token: string): void {
    localStorage.removeItem('avulsaToken');
    localStorage.setItem('avulsaToken', token);
  }

  public savePackToken(token: string): void {
    localStorage.removeItem('packToken');
    localStorage.setItem('packToken', token);
  }

  public saveInventoryToken(token: string): void {
    localStorage.removeItem('balancoToken');
    localStorage.setItem('balancoToken', token);
  }

  public saveComponentCodeToken(token: string): void {
    localStorage.setItem('componentCodeToken', token);
  }

  public saveComponentCode(item: any): void {
    item.map((el:any) => {
      localStorage.removeItem(el.link + 'ComponentCode');
      localStorage.setItem(el.link + 'ComponentCode', el.componentCode);
    })
  }

  public getComponentCode(item: any): string | null {
    return localStorage.getItem(item + 'ComponentCode');
  }

  public getCountToken(): string | null {
    return localStorage.getItem('contagemToken');
  }

  public getEmbarqueToken(): string | null {
    return localStorage.getItem('embarqueToken');
  }

  public getAvulsaToken(): string | null {
    return localStorage.getItem('avulsaToken');
  }

  public getPackToken(): string | null {
    return localStorage.getItem('packToken');
  }

  public getComponentCodeToken(): string | null {
    return localStorage.getItem('componentCodeToken');
  }

  public getInventoryToken(): string | null {
    return localStorage.getItem('balancoToken');
  }

  public getTokenV2(): string | null {
    return localStorage.getItem('tokenV2');
  }

  public saveTenant(tenant: any): void {
    localStorage.removeItem('tenant');
    localStorage.setItem('tenant', tenant);
  }

  public getTenant(): string | null {
    return localStorage.getItem('tenant');
  }

  public saveBranchName(branch: any): void {
    localStorage.removeItem('branchName');
    localStorage.setItem('branchName', branch);
  }

  public getBranchName(): string | null {
    return localStorage.getItem('branchName');
  }

  public saveBranch(branch: any): void {
    localStorage.removeItem('branch');
    localStorage.setItem('branch', branch);
  }

  public getBranch(): string | null {
    return localStorage.getItem('branch');
  }

  public signOut(): void {
    this.cleanVariablesStorage();

    this.router.navigate(['/login']);
  }

  public saveUsername(username: any): void {
    localStorage.removeItem('username');
    localStorage.setItem('username', username);
  }

  public getUsername(): string | null {
    return localStorage.getItem('username');
  }

  public getItem(item: string): string | null {
      return localStorage.getItem(item);
  }
   public saveItem(name: string, data: any): void {
       localStorage.setItem(name, data)
  }

  public getUserCode(): string | null {
    const token = this.getTokenV2();
  
    if (!token) {
      return null;
    }
  
    try {
      const decoded: any = jwtDecode(token);
      return decoded.sub || null;
    } catch (error) {
      return null;
    }
  }
}
